<div class="container" [class.call-fullscreen]="isFullscreen" [class.middle-fullscreen]="assistance.procedure">

  <!-- Editor tools window -->
  <app-editor-tools
    *ngIf="editorShown && !isFreezing"
    [tool]="editorTool"
    (onEditorUpdate)="onEditorUpdate($event)"
  ></app-editor-tools>

  <!-- Videocall module -->
  <videocall-module
    #videocallModule
    lazy="true"
    [attr.mode]="mode"
    render-loop="false"
    [attr.logging]="!environment.production"
    [attr.webrtc-broker-endpoint]="environment.videocall.webrtcBrokerEndpoint"
    [attr.webrtc-broker-signaller]="environment.videocall.webrtcBrokerSignaller"
    [attr.resource-manager-endpoint]="environment.resourceManager.endpoint"
    [attr.resource-manager-bucket]="environment.resourceManager.bucket"
    resource-manager-realm="event"
    [attr.room-id]="assistance.id"
  ></videocall-module>
  <mat-icon class="fullscreen noselect" (click)="goFullscreen()">fullscreen</mat-icon>

  <!-- Mute / Unmute -->
  <button *ngIf="peerConnected" mat-stroked-button class="mute" [class.off]="isMuted" color="white-mute" (click)="mute()"><mat-icon>{{isMuted ? 'mic_off' : 'mic_none'}}</mat-icon></button>

  <!-- Recorder -->
  <ng-container *ngIf="assistanceType != AssistanceType.EXTERNAL_MAINTENANCE">
    <button *ngIf="peerConnected && canRecord && recordingStatus == RecordingStatus.READY" mat-flat-button color="white-red" class="record-btn" (click)="startRecording()">
      <mat-icon>radio_button_checked</mat-icon>
      Start recording
    </button>
    <button *ngIf="peerConnected && canRecord && recordingStatus == RecordingStatus.RECORDING" mat-flat-button color="white-red" class="record-btn" (click)="stopRecording(true)">
      <mat-icon>radio_button_checked</mat-icon>
      Stop recording
    </button>
    <div class="record-info">
      <mat-icon *ngIf="recordingStatus == RecordingStatus.STARTING || recordingStatus == RecordingStatus.RECORDING || recordingStatus == RecordingStatus.STOPPING" class="recording noselect">radio_button_checked</mat-icon>
      <span *ngIf="recordingStatus == RecordingStatus.STARTING">Recording is starting...</span>
      <span *ngIf="recordingStatus == RecordingStatus.RECORDING">REC</span>
      <span *ngIf="recordingStatus == RecordingStatus.STOPPING">Recording is stopping...</span>
    </div>
  </ng-container>

  <!-- AR editor -->
  <button *ngIf="peerConnected && canEditScene && freezed && !isFreezing" mat-fab color="primary" class="unlock-btn" (click)="unfreeze()">
    <mat-icon>lock_open</mat-icon>
  </button>
  <eco-fab-speed-dial *ngIf="peerConnected && canEditScene && !freezed && !isFreezing" animationMode="scale">
    <eco-fab-speed-dial-trigger>
      <button (click)="updateUI()" mat-fab color="primary"><mat-icon>add</mat-icon></button>
    </eco-fab-speed-dial-trigger>

    <eco-fab-speed-dial-actions>
      <!--<button *ngIf="!freezed" mat-mini-fab color="white" (click)="freeze()"><mat-icon>lock</mat-icon></button>
      <button *ngIf="freezed" mat-mini-fab color="white" (click)="unfreeze()"><mat-icon>lock_open</mat-icon></button>-->
      <button mat-mini-fab color="white" (click)="clearDrawings()"><mat-icon>highlight_off</mat-icon></button>
      <button mat-mini-fab color="white" (click)="arrow()"><mat-icon>north_east</mat-icon></button>
      <!--<button mat-mini-fab color="white" (click)="shape()"><mat-icon>category</mat-icon></button>-->
      <!--<button mat-mini-fab color="white" (click)="measure()"><mat-icon>straighten</mat-icon></button>-->
      <button mat-mini-fab color="white" (click)="freedraw()"><mat-icon>edit</mat-icon></button>
      <!--<button mat-mini-fab color="white" (click)="selectText()"><mat-icon>title</mat-icon></button>-->
      <button mat-mini-fab color="white" (click)="addImage()"><mat-icon>image</mat-icon></button>
      <button mat-mini-fab color="white" (click)="addModel()"><mat-icon>3d_rotation</mat-icon></button>
      <button mat-mini-fab color="white" (click)="addPdf()"><mat-icon>picture_as_pdf</mat-icon></button>
      <button *ngIf="assistanceType != AssistanceType.EXTERNAL_MAINTENANCE" mat-mini-fab color="white" (click)="addFromLibrary()"><mat-icon>drive_folder_upload</mat-icon></button>
    </eco-fab-speed-dial-actions>
  </eco-fab-speed-dial>

</div>
